export const filters = {
    BATCH_STATUSES: [
        {
            key: 'transactionHistoryDetails.processed',
            value: 'processed',
        },
        {
            key: 'transactionHistoryDetails.rejected',
            value: 'rejected',
        },
        {
            key: 'transactionHistoryDetails.error',
            value: 'error',
        },
        {
            key: 'transactionHistoryDetails.processing',
            value: 'processing',
        },
        {
            key: 'transactionHistoryDetails.failed',
            value: 'failed',
        },
    ],

    BATCH_TYPES: [
        {
            key: 'wallet.topup',
            value: 'buy',
        },
        {
            key: 'wallet.receive',
            value: 'deposit',
        },
        {
            key: 'transactionHistoryDetails.withdrawal',
            value: 'withdrawal',
        },
        {
            key: 'transactionHistoryDetails.redeem_voucher',
            value: 'redeem_voucher',
        },
        {
            key: 'transactionHistoryDetails.fto_purchase',
            value: 'fto_purchase',
        },
        {
            key: 'transactionHistoryDetails.marketplace_purchase',
            value: 'marketplace_purchase',
        },
        {
            key: 'transactionHistoryDetails.marketplace_sale',
            value: 'marketplace_sale',
        },
        {
            key: 'transactionHistoryDetails.redeem_token_quest',
            value: 'redeem_token_quest',
        },
        {
            key: 'transactionHistoryDetails.bonus',
            value: 'bonus',
        },
        {
            key: 'transactionHistoryDetails.manual_transfer',
            value: 'manual_transfer',
        },
        {
            key: 'transactionHistoryDetails.locker_fto_purchase',
            value: 'locker_fto_purchase',
        },
        {
            key: 'transactionHistoryDetails.gamification_reward',
            value: 'gamification_reward',
        },
        {
            key: 'transactionHistoryDetails.fan_shop_purchase',
            value: 'fan_shop_purchase',
        },
        {
            key: 'transactionHistoryDetails.regulatory_restriction',
            value: 'regulatory_restriction',
        },
    ],

    CUSTOM_AMOUNTS: [
        {
            text: '0-500',
            value: {
                min: 0,
                max: 500,
            },
        },
        {
            text: '500-1000',
            value: {
                min: 500,
                max: 1000,
            },
        },
        {
            text: '1000-2500',
            value: {
                min: 1000,
                max: 2500,
            },
        },
        {
            text: '2500-5000',
            value: {
                min: 2500,
                max: 5000,
            },
        },
        {
            text: '5000+',
            value: {
                min: 5000,
            },
        },
    ],
};